import { useTranslation } from 'react-i18next';

export default function useTermTagsUpdate(){
  const  {t} = useTranslation();
  return {t};
}